<template>
  <nav id="app_mobile_tabbar" class="d-flex d-md-none bg-white">
    <template v-for="tab in tabs">
      <router-link
          v-if="is_authenticated || tab.public"
          :key="tab.url"
          :to="tab.url"
          class="tabbar_item"
          :class="{tabbar_item_active: isActive(tab.url)}"
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor">
          <path :d="tab.icon"/>
        </svg>
        <span>{{ tab.title }}</span>
      </router-link>
      <span v-else :key="tab.url" class="tabbar_item tabbar_item_locked">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="#a0a0a0">
          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
        </svg>
        <span>{{ tab.title }}</span>
      </span>
    </template>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "mobile-tabbar",
  computed: {
    ...mapGetters('user', [
      'is_authenticated',
    ]),
  },
  data() {
    return {
      tabs: [
{url: '/transactions', title: 'تراکنش‌ها', icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z'},
{url: '/gateways', title: 'درگاه‌ها', icon: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z'},
        {url: '/', title: 'پیشخوان', public: true, icon: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z'},
{url: '/tickets', title: 'پشتیبانی', public: true, icon: 'M12 1a9 9 0 0 0-9 9v7a3 3 0 0 0 3 3h3v-8H5v-2a7 7 0 1 1 14 0v2h-4v8h3a3 3 0 0 0 3-3v-7a9 9 0 0 0-9-9z'},
        {url: '/user-setting', title: 'تنظیمات', icon: 'M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z'},
      ],
    };
  },
  methods: {
    isActive(url) {
      return url === '/' ? this.$route.path === '/' : this.$route.path.indexOf(url) === 0;
    },
  },
}
</script>

<style scoped>
#app_mobile_tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  z-index: 15;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid rgba(125, 125, 125, .2);
}

.tabbar_item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  font-size: 11px;
  color: #a0a0a0;
}

.tabbar_item_active {
  color: #00bea5;
  font-weight: 700;
}

.tabbar_item_locked {
  cursor: not-allowed;
  opacity: .6;
}

.tabbar_item_active:before {
  content: "";
  position: absolute;
  top: 0;
  width: 36px;
  height: 3px;
  border-radius: 0 0 3px 3px;
  background-color: #00bea5;
}
</style>
